import React, { useEffect, useState } from "react";
import axios from "axios";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API, fehler, oeffnen } from "./shared";

const q = (v) => (v == null ? "–" : `${String(v).replace(".", ",")} %`);
const Pfeil = ({ jetzt, vor, gutHoch = true }) => {
  if (jetzt == null || vor == null || jetzt === vor) return null;
  const besser = gutHoch ? jetzt > vor : jetzt < vor;
  return <span className={`text-xs ${besser ? "text-[#4F6650]" : "text-[#C2452F]"}`}> {jetzt > vor ? "▲" : "▼"} Vorjahr {q(vor)}</span>;
};

export const QMKennzahlen = () => {
  const [jahr, setJahr] = useState(new Date().getFullYear());
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); axios.get(`${API}/kennzahlen?jahr=${jahr}`).then((r) => setD(r.data)).catch(fehler); }, [jahr]);
  return (
    <div className="space-y-4" data-testid="qm-kennzahlen">
      <div className="flex items-center gap-2">
        <select className="rounded-md border px-2 py-1 text-sm" value={jahr} onChange={(e) => setJahr(Number(e.target.value))} data-testid="kennzahlen-jahr">
          {[0, 1, 2].map((i) => new Date().getFullYear() - i).map((j) => <option key={j}>{j}</option>)}
        </select>
        <span className="text-xs text-[#8E7B71]">Zuordnung nach Kursende · Ziel Erfolgsquote ≥ {d?.ziel_erfolgsquote ?? 85} %</span>
        <Button size="sm" variant="outline" className="ml-auto" onClick={() => oeffnen(`/kennzahlen/pdf?jahr=${jahr}`)} data-testid="kennzahlen-pdf"><FileText size={14} className="mr-1" />PDF</Button>
      </div>
      {d && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[["Teilnehmende", d.gesamt.teilnehmende], ["Erfolgsquote", q(d.gesamt.erfolgsquote)], ["Abbruchquote", q(d.gesamt.abbruchquote)],
              ["Verbleib in Arbeit", `${q(d.verbleib.quote)} (${d.verbleib.antworten} Antw.)`]].map(([l, v]) => (
              <div key={l} className="bg-white rounded-xl border border-[#F0E6DC] p-4" data-testid={`kennzahl-${l.split(" ")[0].toLowerCase()}`}>
                <p className="text-xs uppercase tracking-wider text-[#8E7B71]">{l}</p><p className="text-2xl font-semibold mt-1">{v}</p>
              </div>
            ))}
          </div>
          <div className="bg-white rounded-xl border border-[#F0E6DC] overflow-x-auto">
            <table className="w-full text-sm" data-testid="kennzahlen-tabelle">
              <thead className="text-xs text-[#8E7B71] text-left"><tr>{["Maßnahme", "TN", "Nichtantritt", "Abbruch", "Beendet", "Bestanden", "Erfolg", "Abbruchquote", "Vermittlung"].map((h) => <th key={h} className="p-2">{h}</th>)}</tr></thead>
              <tbody className="divide-y divide-[#F6E3DA]">
                {d.massnahmen.map((m) => (
                  <tr key={m.massnahme}>
                    <td className="p-2 font-medium">{m.massnahme}</td><td className="p-2">{m.teilnehmende}</td><td className="p-2">{m.nichtantritt}</td>
                    <td className="p-2">{m.abgebrochen}</td><td className="p-2">{m.beendet}</td><td className="p-2">{m.bestanden}</td>
                    <td className={`p-2 ${m.erfolgsquote != null && m.erfolgsquote < d.ziel_erfolgsquote ? "text-[#C2452F]" : ""}`}>{q(m.erfolgsquote)}<Pfeil jetzt={m.erfolgsquote} vor={m.vorjahr?.erfolgsquote} /></td>
                    <td className="p-2">{q(m.abbruchquote)}<Pfeil jetzt={m.abbruchquote} vor={m.vorjahr?.abbruchquote} gutHoch={false} /></td>
                    <td className="p-2">{q(m.vermittlungsquote)}</td>
                  </tr>
                ))}
                {d.massnahmen.length === 0 && <tr><td className="p-3 text-[#8E7B71]" colSpan={9}>Keine Kurse mit Kursende in {jahr}.</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
